import { BaseModel } from './base-model';
import { VesselInfo } from './types/vessels-model.types';

// strings are matching the migration service response
export enum MigrationState {
    MigrationToNextPlatformInProgress = "migration_to_next_platform_in_progress", // migration is in progress
    MigrationFailed = "migration_failed",
  	Windows = "windows", // ready to begin migration
    MigrationCompleted = "migration_completed", // show app in k8s
    MigrationServiceNotFound = "migration_service_not_found"
}

export enum MigrationChangeEvents {
    StateChanged = "state-changed"
}

export abstract class VesselMigrationModelBase extends EventTarget {
    abstract get migrationState(): MigrationState|null;
    abstract startMigration(): void;
}

let VesselMigrationModel: VesselMigrationModelBase | null = null;

function setVesselMigrationModel(model: VesselMigrationModelBase) {
    VesselMigrationModel = model;
}

export { VesselMigrationModel, setVesselMigrationModel };
